import { BaseService } from "../../core/baseService";
import { ApiResult } from "../../core/types";
import {
  RestaurantSettingsDto,
  RestaurantSpecialHoursDto,
  RestaurantStatusDto,
  SaveRestaurantSettingsDto,
  SaveRestaurantSpecialHoursDto,
} from "../types/restaurantSettings.types";

export class RestaurantSettingsService extends BaseService {
  async getRestaurantSettings(): Promise<ApiResult<RestaurantSettingsDto>> {
    return this.handleRequest<RestaurantSettingsDto>(
      this.client.get("/api/admin/restaurant-settings"),
    );
  }

  async saveRestaurantSettings(
    data: SaveRestaurantSettingsDto,
  ): Promise<ApiResult<RestaurantSettingsDto>> {
    return this.handleRequest<RestaurantSettingsDto>(
      this.client.put("/api/admin/restaurant-settings", data),
    );
  }

  async getRestaurantStatus(): Promise<ApiResult<RestaurantStatusDto>> {
    return this.handleRequest<RestaurantStatusDto>(
      this.client.get("/api/admin/restaurant-settings/status"),
    );
  }

  async addSpecialHours(
    data: SaveRestaurantSpecialHoursDto,
  ): Promise<ApiResult<RestaurantSpecialHoursDto>> {
    return this.handleRequest<RestaurantSpecialHoursDto>(
      this.client.post("/api/admin/restaurant-settings/special-hours", data),
    );
  }

  async updateSpecialHours(
    specialHoursId: string,
    data: SaveRestaurantSpecialHoursDto,
  ): Promise<ApiResult<RestaurantSpecialHoursDto>> {
    return this.handleRequest<RestaurantSpecialHoursDto>(
      this.client.put(
        `/api/admin/restaurant-settings/special-hours/${specialHoursId}`,
        data,
      ),
    );
  }

  async deleteSpecialHours(specialHoursId: string): Promise<ApiResult<void>> {
    return this.handleRequest<void>(
      this.client.delete(
        `/api/admin/restaurant-settings/special-hours/${specialHoursId}`,
      ),
    );
  }
}
